import axios from "axios";

interface APIResponse {
  success: boolean;
  message?: string;
  data?: any | null;
}

const request = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export async function get(url: string): Promise<APIResponse> {
  try {
    const { data } = await request.get(url);
    return { success: true, message: data?.message, data: data?.data };
  } catch (err: any) {
    console.log(err);
    return {
      success: false,
      message: err?.response?.data?.message || "Something went wrong",
      data: null,
    };
  }
}

export async function post(
  url: string,
  body: any,
  config?: any
): Promise<APIResponse | any> {
  try {
    const { data } = await request.post(url, body, config);
    return { success: true, message: data?.message, data: data?.data };
  } catch (err: any) {
    console.log(err);
    return {
      success: false,
      message: err?.response?.data?.message || "Something went wrong",
      data: err.response.data,
    };
  }
}
